import { Sides } from "@project/emerge-types";

/**
 * enumeration of the basic six directions
 * by design it is possible to get the opposing side by inverting the 1-bit
 * LEFT ^ 1 = RIGHT
 */

export const allSides: ReadonlyArray<Sides> = [
  Sides.LEFT,
  Sides.RIGHT,
  Sides.BACK,
  Sides.FRONT,
  Sides.BOTTOM,
  Sides.TOP,
];

export const sideNames: { [index: number]: string } = {
  [Sides.BACK]: "Hinten",
  [Sides.FRONT]: "Vorne",
  [Sides.LEFT]: "Links",
  [Sides.RIGHT]: "Rechts",
  [Sides.TOP]: "Oben",
  [Sides.BOTTOM]: "Unten",
};

export const getOpposingSide = (side: Sides): Sides => {
  return side ^ (1 as Sides);
};
